<app-dialog [dialogType]="dialogType" [hideActions]="true">
  <div class="dialog-content">
    <div class="marked-as-fully-paid">
      <app-icon class="mark-as-paid-icon" [icon]="markAsPaidIcon"></app-icon>
      <span class="amount">{{ markAsPaidAmount | money }}</span>
      <span>{{ 'LABEL.MARKED_AS_FULLY_PAID' | translate }}</span>
    </div>
    <div class="mark-as-paid-animation" #animationRef></div>

    <div class="payment-method">
      {{ 'LABEL.PAYMENT_METHOD_OPTIONAL' | translate }}
    </div>
    <i2g-form-master *ngIf="form" [form]="form">
      <div class="input-fields-wrapper">
        <div
          *ngFor="let choice of defaultPaymentMethods; let i = index"
          class="input-field-wrapper"
        >
          <i2g-radio-field
            class="payment-method-field"
            e2eId="payment-method-{{ i }}"
            fieldId="payment-method-{{ i }}"
            [group]="'paymentMethods'"
            [label]="choice"
            [value]="choice"
            [fieldControl]="paymentMethodRadio"
            i2gTrackable
            [trackingObject]="trackingObject"
            [trackingTapped]="defaultMethodAction"
            [trackingAdditionalProperties]="buttonActionAdditionalProperties"
          >
          </i2g-radio-field>
        </div>

        <i2g-textarea-field
          class="add-note-wrapper"
          fieldId="add_note_field"
          maxlength="1000"
          [placeholder]="'PLACEHOLDER.ADD_DETAILS' | translate"
          [fieldControl]="addNoteTextarea"
          [trackingObject]="trackingObject"
          [trackingAction]="addNoteAction"
        >
        </i2g-textarea-field>

        <div class="send-receipt-field">
          <app-toggle-field
            class="send-receipt-toggle"
            [icon]="featureHighlightIcon"
            [label]="'ACTION.EMAIL_A_RECEIPT' | translate"
            fieldId="email_a_receipt_field"
            [fieldControl]="sendReceiptToggle"
            [trackingObject]="trackingObject"
            trackingIdentifier="send_a_receipt"
            [trackingScreenName]="trackingScreenName"
            [trackingAdditionalProperties]="toggleActionAdditionalProperties"
            (onClickIcon)="showFeatureHighlightDialog()"
          >
          </app-toggle-field>

          <button
            i2gButton
            buttonStyle="tertiary"
            type="button"
            class="preview-receipt-action"
            trackable
            [trackingObject]="trackingObject"
            [trackingAction]="sendPreviewAction"
            [trackingAdditionalProperties]="buttonActionAdditionalProperties"
            (click)="onPreviewReceipt()"
          >
            {{ 'ACTION.PREVIEW_RECEIPT' | translate }}
          </button>
        </div>

        <div class="cta-buttons">
          <button
            i2gButton
            buttonStyle="emphasis"
            i2gTrackable
            [trackingObject]="trackingObject"
            [trackingAction]="confirmMarkAsPaidAction"
            [trackingAdditionalProperties]="buttonActionAdditionalProperties"
            (click)="onSubmit()"
          >
            {{ 'ACTION.DONE' | translate }}
          </button>

          <button
            i2gButton
            buttonStyle="tertiary"
            i2gTrackable
            [trackingObject]="trackingObject"
            [trackingAction]="undoAction"
            [trackingAdditionalProperties]="buttonActionAdditionalProperties"
            (click)="closeDialog()"
          >
            {{ 'ACTION.UNDO' | translate }}
          </button>
        </div>
      </div>
    </i2g-form-master>
  </div>
</app-dialog>
